import { render, staticRenderFns } from "./select-pile.vue?vue&type=template&id=626e02e6&"
import script from "./select-pile.vue?vue&type=script&lang=ts&"
export * from "./select-pile.vue?vue&type=script&lang=ts&"
import style0 from "./select-pile.vue?vue&type=style&index=0&id=626e02e6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports